import React from 'react';
interface RadioOption {
  label: string;
  value: string;
}
interface RadioGroupProps {
  label?: string;
  name: string;
  options: RadioOption[];
  value?: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  className?: string;
}
export function RadioGroup({
  label,
  name,
  options,
  value,
  onChange,
  error,
  required,
  className = ''
}: RadioGroupProps) {
  return <div className={`w-full ${className}`} data-id="element-468">
      {label && <label className="block text-sm font-medium text-navy mb-2" data-id="element-469">
          {label} {required && <span className="text-red-500" data-id="element-470">*</span>}
        </label>}
      <div className="flex flex-wrap gap-4" data-id="element-471">
        {options.map(option => <label key={option.value} className="flex items-center space-x-2 cursor-pointer group" data-id="element-472">
            <div className="relative flex items-center" data-id="element-473">
              <input type="radio" name={name} value={option.value} checked={value === option.value} onChange={e => onChange(e.target.value)} className="peer h-4 w-4 appearance-none rounded-full border border-gray-300 checked:border-navy checked:bg-navy focus:outline-none focus:ring-2 focus:ring-navy focus:ring-offset-1" data-id="element-474" />
              <div className="pointer-events-none absolute inset-0 hidden h-full w-full items-center justify-center peer-checked:flex" data-id="element-475">
                <div className="h-2 w-2 rounded-full bg-white" data-id="element-476"></div>
              </div>
            </div>
            <span className="text-sm text-gray-700 group-hover:text-navy transition-colors" data-id="element-477">
              {option.label}
            </span>
          </label>)}
      </div>
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-478">{error}</p>}
    </div>;
}